import { Component, Input } from "@angular/core";

@Component({
    selector: "sensor-loading",
    templateUrl: "./sensor-loading.component.html",
    styleUrls: ["./sensor-loading.component.scss"]
  })
export class SensorLoadingComponent {
    _loading: boolean;
    
    @Input("loading")
    public get loading() : boolean {
        return this._loading;
    }
    public set loading(loading : boolean) {
        this._loading = loading;
    }
    
    
}